import { useEffect } from "react";

export function useAutoSubmitVote(desc, ref) {
  useEffect(() => {
    if (!desc.autoVote) {
      return;
    }

    const target = ref.current;

    if (!target) {
      return;
    }

    const event = desc.sideEffects?.find(effect => effect.name === 'submit-vote');

    if (event) {
      target.dispatchEvent(new CustomEvent(event.name, event.init));
    }
  }, []);
}